/* src/components/Head.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	detach,
	init,
	noop,
	query_selector_all,
	safe_not_equal
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	return {
		c() {
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1u1dfar\"]", document.head);
			head_nodes.forEach(detach);
			this.h();
		},
		h() {
			document.title = "Ward Sacrament Program";
		},
		m: noop,
		p: noop,
		i: noop,
		o: noop,
		d: noop
	};
}

class Head extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Head;
//# sourceMappingURL=Head.js.map
